import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const PermissionsDetails = ({
  selectedPermission,
  setSelectedPermission,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedPermission(null);
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Permission Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            Description: selectedPermission?.description,
            "System Mudule": selectedPermission?.module?.name,
            Route: selectedPermission?.route,
            Status: selectedPermission?.status ? "Active" : "In Active",
            "Created At":
              selectedPermission?.createdAt &&
              format(selectedPermission?.createdAt, "PP"),
            "Updated At":
              selectedPermission?.updatedAt &&
              format(selectedPermission?.updatedAt, "PP"),
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium">{value}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PermissionsDetails;
